module.exports = __webpack_public_path__ + "static/media/store-in-store_850x520.8ff91bc8.jpg";